import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import FinalizeInvitationsModal from 'srcReact/components/popinsContent/FinalizeInvitationsModal'
import InviteMembersSuccessModal from 'srcReact/components/popinsContent/InviteMembersSuccessModal'
import { redirectToBack } from 'srcReact/helpers/history'
import BackNavigation from '../BackNavigation'
import IconButton from '../IconButton'
import Modal from '../Modal'
import NotFound from '../NotFound'
import Spinner from '../Spinner'
import styles from './styles.module.scss'
import Tabs from '../Tabs'
import User from './components/User'
import InviteByEmail from './components/InviteByEmail'
import OrderByDropdown from '../OrderByDropdown'
import SearchTextBox from '../SearchTextBox'
import InviteButton from './components/InviteButton'
import Carousel from '../Carousel'

function InviteWPMembers({
  id,
  name,
  type,
  order,
  users,
  lastUserRef,
  loading,
  isPagination,
  workplaceId,
  handleSearchMember,
  handleOrderByChange,
  handleSendInvites
}) {
  const { t } = useTranslation()
  const {
    login: { user: loggedInUser },
    common: { isNative, isMobile, isDesktop, isTablet }
  } = useSelector((state) => state)
  const dispatch = useDispatch()
  const [showMatchingInterestInfo, setShowMatchingInterestInfo] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showFinalizeModal, setShowFinalizeModal] = useState(false)
  const [isAllUsersSelected, setIsAllUsersSelected] = useState(false)
  const [membersToInvite, setMembersToInvite] = useState([])
  const [remainingUsers, setRemainingUsers] = useState([])

  useEffect(() => {
    if (users?.length > 0) {
      setRemainingUsers(users)
    }
  }, [users])

  const handleBackButton = () => {
    redirectToBack(isNative)
    // redirectToPage(`/0/home/${type}/${id}`)
  }

  const toggleSelectUsers = () => {
    if (isAllUsersSelected) {
      const updatedMembersInvited = membersToInvite.filter((x) => x.interests_in_common?.length === 0)
      const memberIds = updatedMembersInvited.map((x) => x.id)
      const updatedRemainingUser = users.filter((u) => !memberIds.includes(u.id))
      setMembersToInvite(updatedMembersInvited)
      setIsAllUsersSelected(false)
      setRemainingUsers(updatedRemainingUser)
      return
    }
    const members = remainingUsers.filter((x) => x.interests_in_common?.length > 0)
    const newSelectedUsers = [...membersToInvite, ...members]
    const memberIds = newSelectedUsers.map((x) => x.id)
    const updatedRemainingUsers = remainingUsers.filter((x) => !memberIds.includes(x.id))
    setIsAllUsersSelected(true)
    setMembersToInvite(newSelectedUsers)
    setRemainingUsers(updatedRemainingUsers)
  }

  const onSelectUser = (user) => {
    const updatedMembersInvited = [...membersToInvite, user]
    const updatedRemainingUsers = remainingUsers.filter((u) => u.id !== user.id)
    setMembersToInvite(updatedMembersInvited)
    setRemainingUsers(updatedRemainingUsers)
  }

  const onUnselectUser = (user) => {
    const updatedMembersInvited = membersToInvite.filter((u) => u.id !== user.id)
    const updatedRemainingUser = [user, ...remainingUsers]
    setMembersToInvite(updatedMembersInvited)
    setRemainingUsers(updatedRemainingUser)
  }

  const removeMember = (id) => {
    setMembersToInvite(membersToInvite?.filter((u) => u.id !== id))
  }

  const handleAfterInviteSuccess = () => {
    setShowSuccessModal(true)
    localStorage.removeItem(`group_mixr_invite_${workplaceId}`)
  }

  return (
    <React.Fragment>
      <div className={styles.inviteOuterContainer}>
        <div className={styles.inviteContainer}>
          <BackNavigation
            className={styles.backNavigation}
            titleClassName={styles.backTitle}
            iconClassName={styles.backIcon}
            customHandleBack={handleBackButton}
          />
          <div className={styles.headContainer}>
            <h1
              className={styles.title}
              dangerouslySetInnerHTML={{
                __html: t(`invite_group_mixr.title`, {
                  type: type === 'group' ? t('global.group') : t('global.mixr'),
                  name: name && `'${name}'`
                })
              }}
            />
          </div>

          <Tabs initialActive={0} type='boxed' className={styles.tabs} contentClassName={styles.tabContent}>
            <div onClick={() => {}} label={t('invite_group_mixr.direct.title')}>
              <div className={styles.directInviteContainer}>
                <div className={styles.selectedUsersContainer}>
                  {membersToInvite?.length > 0 && (
                    <Carousel
                      itemsToShow={isDesktop || isTablet ? 3 : 2}
                      breakPoints={[
                        isDesktop
                          ? { width: 1, itemsToShow: 3, itemsToScroll: 2 }
                          : isTablet
                          ? { width: 1, itemsToShow: 2, itemsToScroll: 2 }
                          : isMobile
                          ? { width: 1, itemsToShow: 1, itemsToScroll: 2 }
                          : { width: 1, itemsToShow: 3, itemsToScroll: 2 }
                      ]}
                      itemsToSroll={2}
                      //outSliderContainer
                      className={styles.selectedUsers}
                      itemPadding={[0, 0]}>
                      {membersToInvite.map((member) => {
                        return (
                          <div key={member.id} className={styles.selectedUser}>
                            <IconButton
                              iconName='close24'
                              className={styles.unselectBtn}
                              onClick={() => onUnselectUser(member)}
                            />
                            <span className={styles.name}>{`${member.firstname} ${member.lastname}`}</span>
                          </div>
                        )
                      })}
                    </Carousel>
                  )}
                  {membersToInvite.length > 0 && (
                    <InviteButton inviteCount={membersToInvite.length} onClick={() => setShowFinalizeModal(true)} />
                  )}
                </div>
                <div className={styles.actions}>
                  <SearchTextBox
                    placeholder={isMobile ? t('global.search') : t('formlabel.searchMemberPlaceholder')}
                    handleSearch={handleSearchMember}
                    minimumSearchChar={2}
                    errorMessage={t('member-directory.search_char_error', { character_count: 1 })}
                    cssClass={styles.search}
                    inputCssClass={`${styles.searchInput} `}
                    style='secondary'
                  />

                  {(isDesktop || isTablet) && (
                    <OrderByDropdown
                      className={styles.orderBy}
                      selected={order}
                      handleOrderByChange={handleOrderByChange}
                    />
                  )}
                </div>

                <div className={styles.selectAllContainer}>
                  <IconButton
                    aria-label={t('global.clickForInfo')}
                    iconName='info'
                    iconSize='large24'
                    className={styles.infoButton}
                    onClick={() => setShowMatchingInterestInfo(true)}
                  />
                  <button className={styles.selectBymatching} onClick={toggleSelectUsers}>
                    {isAllUsersSelected
                      ? t('invite_group_mixr.direct.unSelectAll')
                      : t('invite_group_mixr.direct.selectAll')}
                  </button>
                </div>

                <p className={styles.tip}>{t('invite_group_mixr.direct.tip')}</p>

                {(isMobile || isNative) && (
                  <OrderByDropdown
                    containerClassName={styles.orderByContainer}
                    selected={order}
                    handleOrderByChange={handleOrderByChange}
                  />
                )}
                <div className={`${styles.users} ${!loading && users?.length === 0 && styles.noUsers}`}>
                  {!loading && users?.length === 0 ? (
                    <NotFound title={t('global.no_results')} className={styles.notFound} />
                  ) : isPagination || !loading ? (
                    remainingUsers.map((user, index) => {
                      const isLast = users.length === index + 1
                      return (
                        <User
                          user={user}
                          lastUserRef={isLast ? lastUserRef : null}
                          loggedInUserId={loggedInUser.id}
                          selectUser={() => onSelectUser(user)}
                        />
                      )
                    })
                  ) : null}
                </div>
                {loading && <Spinner customCss={styles.loader} />}
              </div>
            </div>
            <div onClick={() => {}} label={t('invite_group_mixr.byEmail.title')}>
              <div className={styles.emailInviteContainer}>
                <p className={styles.tip}>{t('invite_group_mixr.byEmail.tip')}</p>
                <InviteByEmail
                  type={type === 'event' ? 'mixr' : type}
                  id={id}
                  callbackSuccessFun={handleAfterInviteSuccess}
                />
              </div>
            </div>
          </Tabs>
        </div>
      </div>
      <Modal
        isOpen={showMatchingInterestInfo}
        handleClose={() => setShowMatchingInterestInfo(false)}
        title={t('tooltip.matchingInterests.title')}
        subTitle={t('tooltip.matchingInterests.text')}></Modal>
      {showSuccessModal && (
        <Modal isOpen={showSuccessModal} handleClose={() => setShowSuccessModal(false)}>
          <InviteMembersSuccessModal
            // backNavigation={true}
            redirectReactLink={`/0/home/${type}/${id}`}
            closeModal={() => setShowSuccessModal(false)}
          />
        </Modal>
      )}
      {showFinalizeModal && (
        <Modal
          isOpen={showFinalizeModal}
          title={t('popinFinalizeInvitations.title')}
          handleClose={() => setShowFinalizeModal(false)}>
          <FinalizeInvitationsModal
            members={membersToInvite}
            sendInvites={handleSendInvites}
            id={id}
            type='list'
            callback={() => {
              setShowFinalizeModal(false)
              setShowSuccessModal(true)
            }}
            closeModal={() => setShowFinalizeModal(false)}
            removeMember={removeMember}
          />
        </Modal>
      )}
    </React.Fragment>
  )
}

export default InviteWPMembers
